import React from "react";
const ViewAsFilter = (props) => {
    const { name, value, onChange } = props;
    return (React.createElement("div", { className: "d-flex flex-column" },
        React.createElement("div", { className: "form-check w-100" },
            React.createElement("input", { className: "form-check-input", type: "radio", name: name, id: "individual", value: "individual", onChange: onChange, checked: value === "individual" }),
            React.createElement("label", { className: "form-check-label m-0", htmlFor: "individual" },
                "Individual Overall Ranking",
                React.createElement("br", null),
                React.createElement("small", null, "Leaderboard of individuals (including those that are in teams)."))),
        React.createElement("div", { className: "form-check w-100" },
            React.createElement("input", { className: "form-check-input", type: "radio", name: name, id: "team", value: "team", onChange: onChange, checked: value === "team" }),
            React.createElement("label", { className: "form-check-label m-0", htmlFor: "team" },
                "Team Overall Ranking",
                React.createElement("br", null),
                React.createElement("small", null, "Leaderboard of teams."))),
        React.createElement("div", { className: "form-check w-100" },
            React.createElement("input", { className: "form-check-input", type: "radio", name: name, id: "combined", value: "combined", onChange: onChange, checked: value === "combined" }),
            React.createElement("label", { className: "form-check-label m-0", htmlFor: "combined" },
                "Individual and Team Overall Ranking",
                React.createElement("br", null),
                React.createElement("small", null, "Leaderboard of individuals and teams."))),
        React.createElement("div", { className: "form-check w-100" },
            React.createElement("input", { className: "form-check-input", type: "radio", name: name, id: "average-combined", value: "average-combined", onChange: onChange, checked: value === "average-combined" }),
            React.createElement("label", { className: "form-check-label m-0", htmlFor: "average-combined" },
                "Average Ranking",
                React.createElement("br", null),
                React.createElement("small", null, "Leaderboard filtered by average distance (total distance divided by number of team members).")))));
};
export default ViewAsFilter;
